import React, { useState, useEffect } from 'react';
import './index.css';
import '../Referral/Referral.css';
import { IoEyeOutline } from 'react-icons/io5';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';
import AddOffChainModal from '../../components/PopUpModal/AddOffChainModal';
import UserDetailModal from './UserDetailModal';
import StakeDetailModal from './StakeDetailModal';

export default function Validators() {
  const [validators, setValidators] = useState([]);
  const [summary, setSummary] = useState({ totalValidators: 0, totalUsdtInvested: 0 });
  const [loading, setLoading] = useState(false);
  const [stakingData, setStakingData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [pagination, setPagination] = useState({
    limit: 5,
    current: 1,
    totalResults: 0,
    totalPages: 0
  });

  const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
  const BASE_URL = environment === 'production' 
    ? process.env.REACT_APP_PROD_API_URL 
    : environment === 'staging' 
      ? process.env.REACT_APP_STAG_API_URL 
      : process.env.REACT_APP_DEV_API_URL || 'http://localhost:4001';

  const fetchData = async () => {
    setLoading(true);
    try {
      const headers = { "Authorization": `Bearer ${localStorage.getItem("acessToken")}` };
      
      // 1. Fetch Summary
      const summaryRes = await axios.get(`${BASE_URL}/v1/validator-delegator/summary`, { headers });
      setSummary(summaryRes.data.data);

      // 2. Fetch Validators (Paginated)
      const listRes = await axios.get(`${BASE_URL}/v1/validator-delegator/validators`, {
        params: { page: pagination.current, limit: pagination.limit },
        headers
      });
      
      setValidators(listRes.data.data.results);
      setPagination(prev => ({
        ...prev,
        totalResults: listRes.data.data.totalResults,
        totalPages: listRes.data.data.totalPages
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current]);

  const card = [
    {
      heading: 'Total investment',
      value: `$${summary.validatorTotalUsdt?.toFixed(2) || 0}`
    },
    {
      heading: "Total Validator's",
      value: summary.totalValidators || 0
    }
  ];

  const handleView = (data) => {
    setStakingData({ ...data, type: 'validator', wallet: data?.walletAddress, owner: data?.walletAddress });
  }

  const handlePageNumber = (newpage) => {
    setPagination(prev => ({ ...prev, current: newpage }));
  }

  const handleCloseModal = () => {
    fetchData();
    setIsModalOpen(false);
  }

  return (<>
    <div className='stack-card-cont'>
      {card?.map((value, index) => (
        <div className='stack-card-box' key={index}>
          <div className='sc-heading'>{value?.heading}</div>
          <div className='sc-value'>{value?.value}</div>
        </div>
      ))}
    </div>

    <div className="referral_container">
      <div className="referralTable">
        <div className='d-flex justify-content-between flex-wrap gap-2 align-items-center'>
          <h4>Validator Purchase History</h4>
          <div className="filtertablebtn">
            <button onClick={() => setIsModalOpen(true)} type="button" className="filter_btn w-100 h-100 px-4 py-2">
              Add Off-chain
            </button>
          </div>
        </div>
        <div className='w-100 responsiveTableParent'>
          <table className='w-100'>
            <thead className='affTableHeader'>
              <tr>
                <th className='boder-Rght'>Wallet Address</th>
                <th className='boder-Rght'>Stake Type</th>
                <th className='boder-Rght'>Tier</th>
                <th className='boder-Rght'>Status</th>
                <th className='boder-Rght text-center'>Investment Amount</th>
                <th className='boder-Rght'>Transaction</th>
                <th className='boder-Rght'>View</th>
              </tr>
            </thead>
            <tbody className='referralTableBody'>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-5">
                    <Loader />
                  </td>
                </tr>
              ) : validators?.length > 0 ? (
                validators.map((data, index) => (<tr key={index}>
                  <td className='w-25'>{data?.walletAddress}</td>
                  <td>Validator</td>
                  <td className="fw-bold">{data?.tierNumber}</td>
                  <td className={`fw-bold ${data?.status === 'staked' ? 'text-success' : 'text-danger'}`}>{data?.status}</td>
                  <td className="text-center">${data?.priceInUsdt?.toFixed(2)}</td>
                  <td>
                    <a href={`${process.env.REACT_APP_EXPLORER_URL}/tx/${data?.transactionHash}`} target="_blank" rel="noreferrer" className="text-primary text-decoration-none small">
                      {data?.transactionHash?.slice(0, 6)}...{data?.transactionHash?.slice(-4)}
                    </a>
                  </td>
                  <td>
                    <span onClick={() => handleView(data)} className="cursor-pointer">
                      <IoEyeOutline fontSize={20} />
                    </span>
                  </td>
                </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className='data_not fw-bold'>No Validator Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className='w-100 d-flex justify-content-between'>
            <span className='fw-bold'>Showing page {pagination.current} of {pagination.totalPages || 1} (Total: {pagination.totalResults} records)</span>
            <div className='AffTxTableButton'>
              <button disabled={pagination.current === 1} onClick={() => handlePageNumber(pagination.current - 1)}>
                <span>Prev</span>
              </button>
              {(() => {
                const total = pagination.totalPages;
                const current = pagination.current;
                let start = Math.max(1, current - 2);
                let end = Math.min(total, start + 4);
                if (end - start < 4) start = Math.max(1, end - 4);
                const pages = [];
                for (let i = start; i <= end; i++) pages.push(i);
                return pages.map(page => (
                  <button
                    className={`${pagination.current === page && 'activePaginationbtn'}`}
                    key={page}
                    onClick={() => handlePageNumber(page)}
                  >
                    {page}
                  </button>
                ));
              })()}
              <button disabled={pagination.current === pagination.totalPages || pagination.totalPages === 0} onClick={() => handlePageNumber(pagination.current + 1)}>
                <span>Next</span>
              </button>
            </div>
          </div>
      </div>
    </div>
    <AddOffChainModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      type="validator"
    />
    <StakeDetailModal 
      stake={Object.keys(stakingData).length > 0 ? stakingData : null} 
      onClose={() => setStakingData({})} 
    />
  </>);
}
